module.exports = __webpack_public_path__ + "img/stub-espn-content--l.970a514f.png";